

// // src/components/settings/UploadField.jsx
// import React from "react";
// export default function UploadField({ label, name, currentUrl, onChange, accept = ".jpg,.png,.jpeg,.svg" }) {
//   const [imageError, setImageError] = React.useState(false);

//   const handleImageError = () => {
//     setImageError(true);
//   };

//   return (
//     <div>
//       <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
//         {label}
//       </label>

//       {currentUrl && !imageError && (
//         <div className="mt-2">
//           <img
//             //src={`http://localhost:4000${currentUrl}`}
//             src={`https://api.onedesk.digital${currentUrl}`}
//             alt={label}
//             onError={handleImageError}
//             className="h-32 w-auto object-contain rounded border dark:border-gray-600"
//           />
//         </div>
//       )}

//       {currentUrl && imageError && (
//         <div className="mt-2 text-sm text-red-600">
//           Logo file not found on server (previously uploaded file missing)
//         </div>
//       )}

//       <input
//         type="file"
//         name={name}
//         accept={accept}
//         onChange={onChange}
//         className="mt-2 block w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 cursor-pointer dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//       />
//     </div>
//   );
// }

// src/components/settings/UploadField.jsx
import React, { useState } from "react";

export default function UploadField({
  label,
  name,
  currentUrl,           // this is the URL string from backend (e.g. "/uploads/logo.png")
  onChange,
  accept = ".jpg,.png,.jpeg,.svg",
}) {
  const [imageError, setImageError] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState(null);

  const handleImageError = () => {
    setImageError(true);
  };

  const handleFileSelect = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFileName(file.name);
      onChange(e); // pass event to parent
    } else {
      setSelectedFileName(null);
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
        {label}
      </label>

      {/* Show preview only if we have a URL and no error */}
      {currentUrl && typeof currentUrl === "string" && !imageError && (
        <div className="mt-2">
          <img
            src={`http://localhost:4000${currentUrl}`}
            //src={`https://api.onedesk.digital${currentUrl}`}
            alt={label}
            onError={handleImageError}
            className="h-32 w-auto object-contain rounded border dark:border-gray-600"
          />
        </div>
      )}

      {currentUrl && typeof currentUrl === "string" && imageError && (
        <div className="mt-2 text-sm text-red-600">
          Logo file not found on server (previously uploaded file missing)
        </div>
      )}

      {/* Show selected file name if user picked a new file */}
      {selectedFileName && (
        <div className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          Selected: {selectedFileName}
        </div>
      )}

      <input
        type="file"
        name={name}
        accept={accept}
        onChange={handleFileSelect}
        className="mt-2 block w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 cursor-pointer dark:bg-gray-700 dark:border-gray-600 dark:text-white"
      />
    </div>
  );
}